import type { PayloadByExperimentId } from "@hopper-b2b/types";
import { useExperiments } from "./useExperiments";

/**
 * Custom hook to retrieve the payload for a given experiment name.
 *
 * @param {string} expName - The name of the experiment to retrieve the payload for.
 * @returns PayloadByExperimentId[T] | undefined - The payload associated with the specified experiment, or undefined if not found.
 */
export const useGetExperimentPayload = <T extends keyof PayloadByExperimentId>(
  expName: T
): PayloadByExperimentId[T] | undefined => {
  const exps = useExperiments();
  return exps?.experimentPayloads?.[expName] as
    | PayloadByExperimentId[T]
    | undefined;
};
